import { styled } from 'styled-components';

import { mq } from '@/shared/ui/styled';

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 320px;
    padding: 0 10px;

    button {
        height: 44px;
        justify-content: center;
        padding: 14px 16px;

        :first-child {
            width: 238px;
            ${mq.lt.sm} {
                width: initial;
            }
        }

        &.basket-btn {
            &.active {
                background: ${({ theme }) => theme.color.dark};
                color: ${({ theme }) => theme.color.secondary};
            }
        }

        &.fav-btn {
            background-color: ${({ theme }) => theme.color.secondary};
            border: none;
        }

        span {
            margin-left: 8px;

            &.fav-label {
                display: none;
                margin-left: 0;
                ${mq.gt.lg} {
                    display: block;
                    font-weight: 500;
                    width: 100%;
                }
            }
        }

        ${mq.gt.lg} {
            width: 238px;
        }

        ${mq.lt} {
            &:last-child {
                margin: 0 auto;
            }
        }
    }

    ${mq.gt.md} {
        max-width: 539px;
    }
`;
